module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "piv"
    }
  }), _vm._v(" Copyright © 1996 by James Carroll"), _c('br'), _vm._v("\nAll rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.hmhco.com/popular-reading",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _c('br'), _vm._v("\nCarroll, James, date."), _c('br'), _vm._v("\nAn American requiem : God, my father, and the war that came"), _c('br'), _vm._v("\nbetween us / James Carroll,"), _c('br'), _vm._v("\np. cm."), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 0-395-77926-x"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 0-395-85993-x (pbk.)"), _c('br'), _vm._v("\n1. Carroll, James, 1943–—Family. 2. Novelists—20th century—Family relationships. 3. Ex-priests, Catholic—United States—Family relationships. 4. Vietnamese Conflict, 1961–1975—Protest movements—United States. 5. Fathers and sons—United States—Biography. 6. Catholics—United States—Biography. I. Title."), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("PS")]), _vm._v("3553."), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("A")]), _vm._v("764"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("Z")]), _vm._v("464 1996 95-52125 "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("CIP")]), _c('br'), _vm._v("\n813'.54—dc20")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("e"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-52454-2"), _c('br'), _vm._v("\nv2.0114")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The author is grateful for permission to quote from the following: Lines from “Vapor Trail Reflected in the Frog Pond,” from "), _c('em', [_vm._v("Body Rags")]), _vm._v(" by Galway Kinnell. Copyright © 1965, 1966, 1967 by Galway Kinnell. Reprinted by permission of Houghton Mifflin Company. All rights reserved. Lines from “Vietnamese,” from "), _c('em', [_vm._v("Growing into Love")]), _vm._v(" by X. J. Kennedy. Reprinted by permission of Curtis Brown Ltd. Copyright © 1969 by X. J. Kennedy. Lines from “Death of Little Boys” from "), _c('em', [_vm._v("Poems: 1922–1947")]), _vm._v(" by Allen Tate. Copyright 1931, 1932, 1937, 1948 Charles Scribner’s Sons; renewed copyright © 1959, 1960 Allen Tate.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0223e7e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 63
// module chunks = 0